import { configureStore } from "@reduxjs/toolkit";
import loginSlice from "../slice/loginSlice";
import wechatSlice from "../slice/wechatSlice";

export default configureStore({
  reducer: {
    login: loginSlice,
    wechat: wechatSlice,
  }
})